import { Helmet } from "react-helmet";
import "../../css/header.css";
import "../../css/media.css";
import { logout } from "../../services/Admin";

export const AdminMenuBar = (props) => {
    const onClickLogoutButton = () => {
        logout().then((res) => {
            if (res.status === 200) {
                window.location.href = "/";
            }
        });
    };
    return (
        <>
            <header id="header">
                <Helmet>
                    <script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
                    <script src="../js/jquery-1.12.4.min.js" type="text/javascript"></script>
                    <script src="../js/jquery-ui-1.10.4.custom.min.js" type="text/javascript"></script>
                    <script src="../js/jquery.easing.1.3.js" type="text/javascript"></script>
                    <script src="../js/prefixfree.min.js" type="text/javascript"></script>
                    <script src="../js/script.js" type="text/javascript"></script>
                </Helmet>
                <div className="header_top">
                    <h1 className="logo">
                        <a href="/admin">알리코</a>
                    </h1>
                </div>

                <div className="lnb">
                    <nav className="menu after eachdown">
                        <h2 className="skip">메뉴</h2>
                        <div className="depth depth1">
                            <ul className="depth_list depth1_list cf">
                                <li className="depth_item depth1_item" onMouseEnter={() => {}}>
                                    <a
                                        target="_self"
                                        className="depth_text depth1_text"
                                        id="company-info"
                                        style={
                                            props.selected_page === 1 || props.selected_page === 2
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        <span style={{ cursor: "pointer" }}>알리코 소개</span>
                                    </a>
                                    <div className="depth depth2 cf">
                                        <ul className="depth_list depth2_list fl">
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/company-history"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 1
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>회사 연혁 관리</span>
                                                </a>
                                            </li>

                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/certification"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 2
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>인증서 관리</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="depth_item depth1_item has">
                                    <a
                                        target="_self"
                                        className="depth_text depth1_text"
                                        style={
                                            props.selected_page === 3 || props.selected_page === 4
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        <span style={{ cursor: "pointer" }}>사업분야</span>
                                    </a>
                                    <div className="depth depth2 cf">
                                        <div className="menu_title fl">
                                            <div className="innerbox">
                                                <div className="titlebox">
                                                    <p>ALNICO</p>
                                                    <div className="title">사업분야</div>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="depth_list depth2_list fl">
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/product"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 3
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>제품 관리</span>
                                                </a>
                                            </li>

                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/solution"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 4
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>솔루션 관리</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="depth_item depth1_item has">
                                    <a
                                        target="_self"
                                        className="depth_text depth1_text"
                                        style={
                                            props.selected_page === 5 ||
                                            props.selected_page === 6 ||
                                            props.selected_page === 7
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        <span style={{ cursor: "pointer" }}>고객지원</span>
                                    </a>
                                    <div className="depth depth2 cf">
                                        <div className="menu_title fl">
                                            <div className="innerbox">
                                                <div className="titlebox">
                                                    <p>ALNICO</p>
                                                    <div className="title">고객지원</div>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="depth_list depth2_list fl">
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/sales?page=1"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 5
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span style={{ cursor: "pointer" }}>영업상담 관리</span>
                                                </a>
                                            </li>
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/as?page=1"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 6
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span style={{ cursor: "pointer" }}>A/S상담 관리</span>
                                                </a>
                                            </li>
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/documentary?page=1"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 7
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span style={{ cursor: "pointer" }}>자료실 관리</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>

                                <li className="depth_item depth1_item has">
                                    <a
                                        target="_self"
                                        className="depth_text depth1_text"
                                        style={
                                            props.selected_page === 8 || props.selected_page === 9
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        <span style={{ cursor: "pointer" }}>기타정보</span>
                                    </a>
                                    <div className="depth depth2 cf">
                                        <div className="menu_title fl">
                                            <div className="innerbox">
                                                <div className="titlebox">
                                                    <p>ALNICO</p>
                                                    <div className="title">기타정보</div>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="depth_list depth2_list fl">
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/video?page=1"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 8
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>동영상 관리</span>
                                                </a>
                                            </li>
                                            <li className="depth_item depth2_item cf">
                                                <a
                                                    href="/admin/announcement?page=1"
                                                    className="depth_text depth2_text fl"
                                                    target="_self"
                                                    style={
                                                        props.selected_page === 9
                                                            ? {
                                                                  color: "rgb(255, 27, 27)",
                                                                  textShadow: "0 0 1px crimson",
                                                              }
                                                            : {}
                                                    }
                                                >
                                                    <span>채용정보 관리</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <div className="gnbbox cf">
                        <div className="gnbLBox fl cf">
                            <div className="sitebox fl">
                                <div className="sitemap_btn">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div id="sitemap">
                <div className="bgopacity"></div>
                <div className="logout_button" onClick={() => onClickLogoutButton()}>
                    <span>로그아웃</span>
                </div>
                <a href="#none" className="sitmap_close_button">
                    <span></span>
                    <span></span>
                </a>
                <div className="moclapop cf">
                    <ul className="logo fl">
                        <li>
                            <a href="/admin">로고</a>
                        </li>
                    </ul>

                    <div className="content cf">
                        <div className="con1 fl">
                            <ul>
                                <li className="maintit">
                                    <a>알리코 소개</a>
                                </li>
                                <li className="subtit titTop">
                                    <a
                                        href="/admin/company-history"
                                        style={
                                            props.selected_page === 1
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        회사 연혁 관리
                                    </a>
                                </li>
                                <li className="subtit">
                                    <a
                                        href="/admin/certification"
                                        style={
                                            props.selected_page === 2
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        인증서 관리
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="con2 fl">
                            <ul>
                                <li className="maintit">
                                    <a>사업분야</a>
                                </li>
                                <li className="subtit titTop">
                                    <a
                                        href="/admin/product"
                                        style={
                                            props.selected_page === 3
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        제품 관리
                                    </a>
                                </li>
                                <li className="subtit">
                                    <a
                                        href="/admin/solution"
                                        style={
                                            props.selected_page === 4
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        솔루션 관리
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="con3 fl">
                            <ul>
                                <li className="maintit">
                                    <a>고객지원</a>
                                </li>
                                <li className="subtit titTop">
                                    <a
                                        href="/admin/sales?page=1"
                                        style={
                                            props.selected_page === 5
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        영업상담 관리
                                    </a>
                                </li>
                                <li className="subtit">
                                    <a
                                        href="/admin/as?page=1"
                                        style={
                                            props.selected_page === 6
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        A/S상담 관리
                                    </a>
                                </li>
                                <li className="subtit">
                                    <a
                                        href="/admin/documentary?page=1"
                                        style={
                                            props.selected_page === 7
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        자료실 관리
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="con4 fl">
                            <ul>
                                <li className="maintit">
                                    <a>기타정보</a>
                                </li>
                                <li className="subtit titTop">
                                    <a
                                        href="/admin/video?page=1"
                                        style={
                                            props.selected_page === 8
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        동영상 관리
                                    </a>
                                </li>
                                <li className="subtit">
                                    <a
                                        href="/admin/announcement?page=1"
                                        style={
                                            props.selected_page === 9
                                                ? {
                                                      color: "rgb(255, 27, 27)",
                                                      textShadow: "0 0 1px crimson",
                                                  }
                                                : {}
                                        }
                                    >
                                        채용정보 관리
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="nav_bar_frame"></div>
        </>
    );
};
